var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$resize && _vm.$mq.above(767))?_c('div',{staticClass:"section1",style:({
    'background-image':
      'url(' +
      this.hst +
      'uploads/banners/' +
      _vm.page.page.img_full +
      ' )'
  }),attrs:{"id":"intro"}},[_c('div',{staticClass:"section_wrapper clearfix"},[_c('div',{staticClass:"items_group clearfix"},[_c('div',{staticClass:"column one-second column_column"}),_vm._v(" "),_c('div',{staticClass:"column one-second column_column"},[_c('FormPedidos')],1)])])]):_c('div',{staticClass:"section1",style:({
    'background-image':
      'url(' + this.hst + 'uploads/banners/' + _vm.page.page.imga_responsive + ' )'
  }),attrs:{"id":"intro"}},[_c('div',{staticClass:"section_wrapper clearfix"},[_c('div',{staticClass:"items_group clearfix"},[_c('div',{staticClass:"column one-second column_column"},[_c('div',{staticClass:"column_attr",staticStyle:{"padding":"0px"}},[_c('FormPedidos')],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e265e16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 74
// module chunks = 0